import { firebaseConfig } from '../configs/configFirebase.json';

const config = {
  firebaseConfig: firebaseConfig,
  baseUrl: process.env.VUE_APP_API_URL
};

export default config;
